$(function () {
    const manageAlertMessage = function () {

        $('.alert-message-wrapper button').on('click', function () {
            $('.alert-message-wrapper').addClass('hide');
        });
    }

    manageAlertMessage();
});